var map = {
	"./akumulator/akum_600_100.svg": "jncb",
	"./akumulator/akum_600_120.svg": "vC3R",
	"./akumulator/akum_600_160.svg": "6PT9",
	"./akumulator/akum_600_200.svg": "XYNw",
	"./akumulator/akum_600_240.svg": "bHF4",
	"./akumulator/akum_600_320.svg": "GQDI",
	"./akumulator/akum_600_35.svg": "MCsp",
	"./akumulator/akum_600_40.svg": "xFWU",
	"./akumulator/akum_600_55.svg": "nts8",
	"./akumulator/akum_600_65.svg": "7F4b",
	"./akumulator/akum_600_80.svg": "uYUl",
	"./akumulator/akum_800_100.svg": "tBW5",
	"./akumulator/akum_800_120.svg": "AKv8",
	"./akumulator/akum_800_160.svg": "6Rtc",
	"./akumulator/akum_800_200.svg": "rIfN",
	"./akumulator/akum_800_230.svg": "4atk",
	"./akumulator/akum_800_240.svg": "hQW6",
	"./akumulator/akum_800_320.svg": "IsDF",
	"./akumulator/akum_800_35.svg": "W6hz",
	"./akumulator/akum_800_40.svg": "Rh8K",
	"./akumulator/akum_800_400.svg": "+0I2",
	"./akumulator/akum_800_460.svg": "yeP5",
	"./akumulator/akum_800_55.svg": "vmFP",
	"./akumulator/akum_800_65.svg": "3TYl",
	"./akumulator/akum_800_80.svg": "dWbO",
	"./confi-dso.jpg": "Bb5V",
	"./confi-dso.svg": "AWjK",
	"./kiwi.svg": "bnvP",
	"./pdf.svg": "ALdf",
	"./pdf2.svg": "YqVH",
	"./szafa/szafa_dso_24.svg": "TT0C",
	"./szafa/szafa_dso_36.svg": "wlZf",
	"./szafa/szafa_dso_42.svg": "ffWw",
	"./szafa/szafa_dso_45.svg": "isdj",
	"./szafa/szafa_dso_50.svg": "71AO",
	"./urzadzenia/bg_bosch.b0de4ac.svg": "nBwM",
	"./urzadzenia/bg_bosch.png": "v/TD",
	"./urzadzenia/bg_bosch.svg": "LMXp",
	"./urzadzenia/dso_cokol.svg": "Q0kR",
	"./urzadzenia/dso_kolka.svg": "XtnG",
	"./urzadzenia/listwa.svg": "00sp",
	"./urzadzenia/listwa_1.svg": "03lB",
	"./urzadzenia/listwa_2.svg": "zeb4",
	"./urzadzenia/listwa_3.svg": "7RNz",
	"./urzadzenia/listwa_4.svg": "usB0",
	"./urzadzenia/mikrofon.png": "mrCy",
	"./urzadzenia/mikrofon.svg": "iQyx",
	"./urzadzenia/panel_sygnalizacyjny.svg": "80dH",
	"./urzadzenia/wariant2.png": "PECI",
	"./urzadzenia/wariant3.png": "BQp8",
	"./urzadzenia/wariant4.png": "aG/8",
	"./urzadzenia/wentylator.png": "328E",
	"./urzadzenia/wentylator.svg": "ELSO",
	"./urzadzenia/wzmacniacz.svg": "DYdb",
	"./urzadzenia/zasilacz.svg": "ouAQ",
	"./urzadzenia/zaslepka.svg": "PWvb",
	"./wzmacniacz.svg": "gRh0"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "czpq";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*$
// module id = czpq
// module chunks = 1